import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import OTPInput, { ResendOTP } from 'otp-input-react';
import { useVerifyLoginOTP } from '../../hooks/useRegisterData';
import OTPValidationModal from '../../components/OTPModal/OTPValidationModal';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const LoginOTPPopUp = ({
  userId,
  transactionId,
  resendOTP,
  handleClose,
  showAlert,
  emailData,
  stagingId,
}) => {
  const [OTPLogin, setOTPLogin] = useState('');
  const [loading, setLoading] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [otpTransactionData, setOtpTransactionData] = useState({
    transactionId: '',
    pan: '',
    dob: '',
    dataSource: '',
    mobile: '',
  });
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const onSuccess = (data) => {
    setLoading(false);
    if (data?.status === 200) {
      const body = data?.data?.body || {};
      const { accessToken, KycMode, allStepDone, dataSource } = body;

      if (body?.ckycOtpSent === true) {
        setOtpTransactionData({
          transactionId: body?.transactionId,
          pan: body?.pan,
          dob: body?.dob,
          dataSource,
          mobile: body?.mobile,
        });
        setShowOTPModal(true);
        return;
      }

    //   sessionStorage.clear();
      // Save session/auth
      setAuth({ accessToken });
      sessionStorage.setItem('user', accessToken);
      sessionStorage.setItem('KycMode', KycMode);
      let path = KycMode || allStepDone ? '/esign' : '/kyc';
      if (KycMode || allStepDone)
        return navigate(path, { state: { data: 'success', KycMode: allStepDone ? false : true } });

      let stateData = { data: 'success' };

      // Handle dataSource-based navigation
      if (body.dataSource) stateData.dataSource = body;
      if (dataSource.dataFetchedFrom === 'Digilocker' && body.fetchFromDigilocker) {
        stateData.dataSource = dataSource;
      } else if (
        dataSource.digilockerRequired &&
        dataSource.pdfDataPrint === 'Digilocker' &&
        !dataSource.fetchFromDigilocker
      ) {
        stateData.dataSource = dataSource;
        path = '/digilocker';
      }

      return navigate(path, { state: stateData });
    }

    if (data?.response?.status === 400) showAlert('error', data?.response?.data?.message);
    if (data?.response?.status === 500) showAlert('error', 'Oops something went wrong.');
  };

  const handleOTPSuccess = (data) => {
    if (data?.data?.status === 200) {
      setAuth({ accessToken: data?.data?.body?.accessToken });
      sessionStorage.setItem('user', data?.data?.body?.accessToken);
      sessionStorage.setItem('KycMode', data?.data?.body?.KycMode);
      sessionStorage.setItem('isAssistedMode', data?.data?.body?.isAssistedMode);
      if (
        data?.data?.body?.dataSource === 'Digilocker' ||
        data?.data?.body?.dataSource?.dataFetchedFrom === 'Digilocker'
      ) {
        return navigate('/digilocker', {
          state: {
            data: 'success',
            transactionId: otpTransactionData?.transactionId,
            userId: data?.data?.body?.userId,
            tenantId: data?.data?.body?.tenantId,
          },
        });
      }
      let body = data?.data?.body;
      if (body?.dataSource === 'Digilocker' || body?.dataSource?.dataFetchedFrom === 'Digilocker') {
        navigate('/digilocker', {
          state: {
            data: 'success',
            transactionId: otpTransactionData?.transactionId,
            userId: body?.userId,
            tenantId: body?.tenantId,
          },
        });
      }
      //handle here if digilocker pdf print then throw in digilocker page only  else return /kyc
      setShowOTPModal(false);
      showAlert('success', 'OTP validated successfully. Redirecting...');
      setTimeout(() => {
        navigate('/kyc', {
          state: {
            data: 'success',
            transactionId: otpTransactionData?.transactionId,
            userId: body?.userId,
            tenantId: body?.tenantId,
          },
        });
      }, 1500);
    } else {
      showAlert(
        'error',
        data?.data?.message ||
          data?.response?.data?.message ||
          'Oops something wrong while validating the CKYC OTP',
      );
    }
  };

  const onError = () => {
    setLoading(false);
    showAlert('error', 'Oops something went wrong.');
  };

  const handleOTPModalClose = () => {
    setShowOTPModal(false);
  };

  const { mutate: VerifyLoginOTP } = useVerifyLoginOTP(onSuccess, onError);

  const loginOTPVerify = () => {
    if (OTPLogin?.length !== 6) {
      showAlert('error', 'Please enter a valid 6-digit OTP');
      return;
    }
    setLoading(true);
    const reqDto = { stagingId, userId, transactionId: transactionId, otp: Number(OTPLogin) };
    VerifyLoginOTP(reqDto);
  };

  return (
    <div className="otp-content">
      {/* Close button — only when not emailData mode */}
      {!emailData && (
        <button type="button" className="modal-close" onClick={handleClose} aria-label="Close">
          <span className="material-symbols-outlined">close</span>
        </button>
      )}

      {/* Header */}
      <div className="otp-header">
        <div className="otp-icon-wrapper">
          <span className="material-symbols-outlined">security</span>
        </div>
        <h2 className="otp-title">Two-Factor Auth</h2>
        <p className="otp-subtitle">Enter your login verification code</p>
      </div>

      {/* OTP form */}
      <form
        className="otp-form"
        onSubmit={(e) => {
          e.preventDefault();
          if (OTPLogin.length === 6) {
            loginOTPVerify();
          }
        }}
      >
        <div className="otp-inputs">
          <OTPInput
            value={OTPLogin}
            onChange={setOTPLogin}
            autoFocus
            OTPLength={6}
            otpType="number"
            placeholder="······"
            disabled={false}
          />
        </div>

        {/* Verify button */}
        <button
          type="submit"
          className="submit-btn otp-submit"
          onClick={loginOTPVerify}
          disabled={loading}
          // disabled={loading || OTPLogin.length !== 6}
        >
          {loading ? (
            <>
              <CircularProgress size={18} color="inherit" style={{ marginRight: 8 }} />
              Verifying...
            </>
          ) : (
            <>
              Verify &amp; Proceed
              <span className="material-symbols-outlined text-sm-icon ml-1">arrow_forward</span>
            </>
          )}
        </button>
      </form>

      {/* Resend + change number */}
      <div className="otp-actions">
        <ResendOTP
          maxTime={120}
          onResendClick={() => resendOTP('E')}
          style={{ display: 'flex', justifyContent: 'center' }}
          renderButton={({ remainingTime, ...buttonProps }) => (
            <button {...buttonProps} className="otp-resend">
              <span className="material-symbols-outlined text-sm-icon">history</span>
              {remainingTime !== 0 ? `Resend OTP in ${remainingTime}s` : 'Resend OTP'}
            </button>
          )}
          renderTime={() => null}
          type="button"
          onClick={resendOTP}
        />
      </div>

      <OTPValidationModal
        open={showOTPModal}
        onClose={handleOTPModalClose}
        onSuccess={handleOTPSuccess}
        transactionData={otpTransactionData}
      />
    </div>
  );
};

export default LoginOTPPopUp;
